import { CliError } from "@/lib/cli/cli-error";
import { CLI_ERROR_CODES } from "@/lib/shared/errors-constants";
import { timerDelayMs } from "./timer-delay-ms";

export function interruptibleSleep(seconds: number): Promise<void> {
  return new Promise((resolve, reject) => {
    const onInterrupt = () => {
      clearTimeout(timer);
      reject(
        new CliError("Follow interrupted.", 130, {
          code: CLI_ERROR_CODES.INTERRUPTED,
        }),
      );
    };
    const timer = setTimeout(() => {
      process.removeListener("SIGINT", onInterrupt);
      resolve();
    }, timerDelayMs(seconds));
    process.once("SIGINT", onInterrupt);
  });
}
